export default __webpack_public_path__ + "static/media/detail_small_9_6.da496c45.jpg";